import type {
  TEmailChannel,
  TEmailChannelExhibitionType,
  TEmailChannelGroup,
} from "./email-channel-types-helper";

const groupEmailChannels = (
  channels: TEmailChannel[] = [],
  exhibitionTypes: TEmailChannelExhibitionType[] = []
): TEmailChannelGroup[] => {
  const groups = new Map<string, TEmailChannel[]>();

  channels.forEach((channel) => {
    const exhibitionTypeID = channel.exhibition_type_id?.toString();
    if (!exhibitionTypeID) return;

    const current = groups.get(exhibitionTypeID) ?? [];
    current.push(channel);
    groups.set(exhibitionTypeID, current);
  });

  const exhibitionOrder = new Map(
    exhibitionTypes.map(({ id }, index) => [id.toString(), index])
  );

  return Array.from(groups.entries())
    .map(([exhibitionTypeID, groupedChannels]) => {
      const relation = groupedChannels.find(
        ({ relExhibitionType }) => relExhibitionType?.title
      )?.relExhibitionType;
      const organizerExhibitionType = exhibitionTypes.find(
        ({ id }) => id.toString() === exhibitionTypeID
      );
      const sortedChannels = [...groupedChannels].sort(
        (a, b) => Number(b.id) - Number(a.id)
      );

      return {
        key: `exhibition-type-${exhibitionTypeID}`,
        exhibitionTypeID,
        title:
          relation?.title ??
          organizerExhibitionType?.title ??
          exhibitionTypeID,
        channels: sortedChannels,
        total: sortedChannels.length,
        active: sortedChannels.filter(({ is_active }) => is_active === true)
          .length,
      };
    })
    .sort(
      (a, b) =>
        (exhibitionOrder.get(a.exhibitionTypeID) ?? Number.MAX_SAFE_INTEGER) -
        (exhibitionOrder.get(b.exhibitionTypeID) ?? Number.MAX_SAFE_INTEGER)
    );
};

export default groupEmailChannels;
